//GLOBAL - components from npm
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactHtmlParser from 'react-html-parser'
import DEFAULT from '../../build/images/default.png';

import "./interaction-email.css";
// import { ReactComponent as RepeatRightIcon } from "../../build/images/icons/repeat-right.svg";
// import { ReactComponent as RepeatLeftIcon } from "../../build/images/icons/repeat-left.svg";
// import { ReactComponent as FavoriteIcon } from "../../build/images/icons/favorite.svg";
// import { ReactComponent as FavoriteIconEnable } from "../../build/images/icons/favoritethree.svg";
import CarrousselAttach from "../mail-section/CarrousselAttach";
// import { changeFavoriteMail, registerFavoriteMail } from "../../actions";

let pathname = localStorage.getItem("pathname");
let port = localStorage.getItem("port");

function InteractionEmail({
  mail,
}) {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState("");
  
    return (
      <div className="attendance__mail-container__preview" id="attendance__mail-container" onClick={() => setVisible(!visible)}>
      {/* <div className="attendance__mail-container__header">
        <div className="attendance__mail-container__header-user">
          <div className="attendance__mail-container__header-user__text">
            <span><b>Assunto: {mail.caption}</b></span>
          </div>
        </div>
      </div>
      <hr className="attendance__mail-container__divider-subject" style={{ opacity: "40%" }}></hr> */}
      <div className="attendance__mail-container__header">
            <div className="attendance__mail-container__header-user">
                <div className="attendance__mail-container__header-user__photo">
                    <img src={DEFAULT} width="36" height="36" className="attendance__mail-container__header-user__photo-img" />
                </div>
                <div className="attendance__mail-container__header-user__text">
                  {/* <span>De:<b>{mail.operator}</b></span> */}
                  <span><b>{mail.recipients.filter(mail => mail.type === 0).map((email, index) => (index !== 0 ? ', '+email.label:email.label))}</b></span>
                  {/* {mail.recipients.filter(mail => mail.type === 0).length !== 0 && <span>De:  {mail.recipients.filter(mail => mail.type === 0).map((email, index) => (index !== 0 ? ', '+email.label:email.label))}</span>} */}
                  {(!visible && mail.recipients.filter(mail => mail.type !== 0).length !== 0) ?
                    <div>
                      <span>Para: </span>
                      <span>{mail.recipients.filter(mail => mail.type !== 0).map((email, index) => (index !== 0 ? ', '+email.label:email.label))}</span>
                    </div>
                    :
                    <div>
                      {mail.recipients.filter(mail => mail.type === 1).length !== 0 && <span>Para:  {mail.recipients.filter(mail => mail.type === 1).map((email, index) => (index !== 0 ? ', '+email.label:email.label))}</span>}
                      {mail.recipients.filter(mail => mail.type === 2).length !== 0 && <span>Cc:  {mail.recipients.filter(mail => mail.type === 2).map((email, index) => (index !== 0 ? ', '+email.label:email.label))}</span>}
                      {mail.recipients.filter(mail => mail.type === 3).length !== 0 && <span>Cco:  {mail.recipients.filter(mail => mail.type === 3).map((email, index) => (index !== 0 ? ', '+email.label:email.label))}</span>}
                    </div>
                  }
                </div>
            </div>
            <div className="attendance__mail-container__header-actions">
                <div className="attendance__mail-container__header-actions__date_preview">
                    <span>{mail.date_sending}</span>
                    {/* (há 2 dias) */}
                </div>
                <div className="attendance__mail-container__header-actions__icons">
                    {/* <div className="attendance__mail-container__header-actions__icons-favorite" onClick={() => changeFavorite(mail.externalcode,mail.id,!mail.favorite)}>
                        {mail.favorite ? <FavoriteIconEnable />:<FavoriteIcon />}
                    </div> */}
                    {/* <div className="attendance__mail-container__header-actions__icons-reply" onClick={() => handleReplyMail(mail)}>
                      <RepeatLeftIcon />
                    </div> */}
                    {/* <div>
                    <RepeatRightIcon />
                    </div> */}
                    {/* <div>
                    <MoreIcon />
                    </div> */}
                </div>
            </div>
      </div>
      <div className={visible ? "attendance__mail-container__body_preview-enable":"attendance__mail-container__body_preview"}>
        <span>
          {ReactHtmlParser(mail.body_msg)}
        </span>
        {mail.attachments.length !== 0 && <hr className="attendance__mail-container__divider" style={{ opacity: "40%" }}></hr>}
        {mail.attachments.map(attach => (
          <CarrousselAttach attach={attach} />
        ))}
      </div>
    </div>
    );
  // }
}

export default InteractionEmail;
